import cx from 'classnames'
import React from 'react'

import styles from './styles.module.css'

const BotVariantIndicator = ({ flowB, className }) => (
  <span
    className={cx(
      styles.botVariantIndicator,
      { [styles.botVariantIndicatorB]: flowB },
      className
    )}
  >
    {flowB ? 'B' : 'A'}
  </span>
)

export default BotVariantIndicator
